import React, {useEffect, useState} from 'react';
import ArrowIcon from 'assets/svgs/actions/arrow-drop.svg';
import ActiveArrowIcon from 'assets/svgs/actions/arrow-drop-white.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import LocationIcon from 'assets/svgs/common/location.svg';
import ActiveLocationIcon from 'assets/svgs/common/location-white.svg';
import {ReactComponent as SearchIcon} from 'assets/svgs/common/search.svg';
import EarthIcon from 'assets/svgs/common/earth.svg';
import StarIcon from 'assets/svgs/common/star.svg';
import StarActive from 'assets/svgs/common/star-fill.svg';

import {useDispatch} from 'react-redux';
import {updateCategory} from 'actions/categoryActions';
import DeleteIcon from 'assets/svgs/actions/icon-clear.svg';
import messages from './messages';

const Countries = ({list, className, selectedCountryId, onChange}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const selected = list.find((c) => c._id === selectedCountryId);
  const getLabel = selected ? selected.title : messages.countries;
  const dispatch = useDispatch();

  useEffect(() => {
    const countries = list
      .filter(
        (f) => f.title?.toLowerCase().indexOf(searchKey.toLowerCase()) > -1
      )
      .sort((a, b) => b.isFavorite - a.isFavorite);

    setFilterList(countries);
  }, [list, searchKey]);

  const onFav = (country) => {
    const newList = [...filterList]
      .map((c) =>
        c._id === country._id ? {...c, isFavorite: !c.isFavorite} : c
      )
      .sort((a, b) => b.isFavorite - a.isFavorite);

    setFilterList(newList);
    dispatch(
      updateCategory([{_id: country._id, isFavorite: !country.isFavorite}])
    );
  };
  return (
    <div
      className={`actions-btn filter-item ${className || ''} countries-action`}
    >
      <OutsideClickHandler
        onOutsideClick={() => {
          setIsOpen(false);
        }}
      >
        <>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            data-toggle="collapse"
            className={`${
              isOpen || selected ? '' : 'collapsed'
            } text-capitalize bg-white d-flex justify-content-between align-items-center px-3`}
            aria-expanded={!!(isOpen || selected)}
          >
            <img src={ActiveLocationIcon} className="active-img mr-3" alt="" />
            <img src={LocationIcon} className="deactive-img mr-3" alt="" />
            {getLabel}
            <img
              onClick={(e) => {
                e.stopPropagation();
                onChange(null);
                setIsOpen(false);
              }}
              src={selected ? DeleteIcon : isOpen ? ActiveArrowIcon : ArrowIcon}
              className="ml-2"
              alt=""
            />
          </button>

          <div className={`collapse select-list-open ${isOpen ? 'show' : ''}`}>
            <div className="link-action">
              {selected && (
                <>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      onChange(null);
                      setIsOpen(false);
                    }}
                    className="bg-gray4 text-capitalize"
                  >
                    <img
                      alt=""
                      className="mr-2"
                      src={LocationIcon}
                      width={15}
                    />
                    <span className="country-name">Country</span>
                  </button>
                  <hr className="m-0" />
                </>
              )}

              <div className="search-countries bg-gray4">
                <span className="icon-search">
                  <SearchIcon />
                </span>
                <input
                  type="text"
                  onKeyUp={(e) => {
                    setSearchKey(e.target.value);
                  }}
                  placeholder="Search"
                />
              </div>
              <hr className="m-0" />

              {filterList.map((country) => (
                <React.Fragment key={country._id}>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      onChange(country);
                      setIsOpen(false);
                    }}
                    className="bg-gray4 text-capitalize"
                  >
                    <span
                      aria-hidden
                      className="mr-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        onFav(country);
                      }}
                    >
                      <img
                        src={country.isFavorite ? StarActive : StarIcon}
                        alt=""
                      />
                    </span>
                    <span className="mr-3">
                      <img
                        alt=""
                        className="border round"
                        src={`${country.avatar}`}
                        onError={(e) => (e.target.src = EarthIcon)}
                        width={25}
                      />
                    </span>
                    <span className="country-name">{`${country.title}`}</span>
                  </button>
                  <hr className="m-0" />
                </React.Fragment>
              ))}
            </div>
          </div>
        </>
      </OutsideClickHandler>
    </div>
  );
};
export default Countries;
